module.exports = __webpack_public_path__ + "static/media/tinyworldmk_2.5977f28c.jpg";